(function () {
  'use strict';

  // Add body class so CSS can clear the fixed chat launcher from footer/contact.
  document.body.classList.add('has-ocu-chat');

  // Keep native constraint validation (including focus and no-JS fallback),
  // but name the field instead of the browser's generic "this field" prompt.
  var contactForm = document.getElementById('SupportContactForm');
  if (contactForm) {
    contactForm.querySelectorAll('[required]').forEach(function (field) {
      function validate() {
        field.setCustomValidity('');
        var label = field.labels && field.labels[0];
        var name = label ? label.textContent.trim() : field.name;
        if (field.validity.valueMissing) {
          field.setCustomValidity('Please complete ' + name + '.');
        } else if (field.validity.typeMismatch && field.type === 'email') {
          field.setCustomValidity('Please enter a valid email address in ' + name + '.');
        }
      }
      field.addEventListener('invalid', validate);
      field.addEventListener('input', validate);
      field.addEventListener('change', validate);
    });
  }

  // ── URL-param autofill ───────────────────────────────────────────────────
  // Runs FIRST and unconditionally: sales links across the site point at
  // /pages/contact?topic=enterprise&deployment_size=6_plus (commercial-copy
  // `sales_contact_url`) and must prefill even if the chat markup is absent.
  (function prefillFromQuery() {
    if (!window.location || !window.location.search) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }

    var topic = (params.get('topic') || '').trim().toLowerCase();
    var size  = (params.get('deployment_size') || params.get('deployment') || '').trim().toLowerCase();

    if (topic === 'enterprise' || size === '6_plus' || size === '6+' || size === '4_plus' || size === 'enterprise' || size === '4+' || size === 'more_than_3') {
      prefillFleet(false);
    }
  })();

  function prefillFleet(selectTopic) {
    var textarea = document.getElementById('SupportContactMessage');
    if (textarea && !textarea.value.trim()) {
      textarea.value = textarea.dataset.enterprisePrefill || 'I would like custom pricing for a larger OcuTrap deployment.';
      textarea.dataset.ocuPrefilled = 'enterprise';
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var issue = document.getElementById('SupportContactIssue');
    if (issue && (selectTopic || !issue.value)) {
      for (var i = 0; i < issue.options.length; i++) {
        if (/fleet pricing/i.test(issue.options[i].text)) { issue.selectedIndex = i; break; }
      }
      issue.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Keep drafts when a visitor switches from support to a fleet inquiry.
  document.querySelectorAll('[data-support-fleet]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !contactForm) return;
      event.preventDefault();
      prefillFleet(true);
      goToForm();
    });
  });

  // Scroll to the contact form and focus its first field. Returns false when
  // the page has no form.
  function goToForm() {
    var band = document.getElementById('contact');
    var form = document.getElementById('SupportContactForm');
    if (!band || !form) return false;
    var first = form.querySelector('input:not([type="hidden"])') || form.querySelector('select, textarea');
    // Contact navigation is immediate, including keyboard-triggered actions.
    band.scrollIntoView({ behavior: 'auto', block: 'start' });
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    return true;
  }

  var chat = document.getElementById('ocuChat');

  // Detect whether a real Shopify Inbox / chat widget is already present and
  // return a function that opens it. Selectors match the set already known to
  // work in assets/ocutrap-redesign.js wireChatClearance(), plus the newer
  // <shopify-chat> custom-element form.
  // Every opener first adds .ocu-inbox-requested: ocutrap-redesign.css keeps
  // Inbox hidden on this page (it sat on the captcha) until the shopper asks
  // for chat, and show() on the hidden element displayed nothing.
  function requested(fn) {
    return { open: function () { document.body.classList.add('ocu-inbox-requested'); fn(); } };
  }

  function shopifyChat() {
    if (window.Shopify && window.Shopify.chat && typeof window.Shopify.chat.open === 'function') {
      return requested(function () { window.Shopify.chat.open(); });
    }
    // Shopify Inbox renders as a <shopify-chat> custom element whose launcher
    // lives in an OPEN shadow root; clicking the host does nothing. The element
    // exposes show()/close(), so prefer that, then the shadow activator button.
    // (Verified against the live widget 2026-08-04.)
    var host = document.querySelector('shopify-chat');
    if (host) {
      if (typeof host.show === 'function') {
        return requested(function () { host.show(); });
      }
      var activator = host.shadowRoot &&
        host.shadowRoot.querySelector('[part="activator"], button.activator, button');
      if (activator) {
        return requested(function () { activator.click(); });
      }
    }
    var el = document.querySelector(
      '#shopify-chat button, .shopify-chat-button, #shopify-chat, #ShopifyChat'
    );
    if (el) {
      var btn = el.matches('button') ? el : el.querySelector('button');
      var target = btn || el;
      return requested(function () { target.click(); });
    }
    return null;
  }

  // ── Live-chat card (progressive enhancement) ─────────────────────────────
  // Server-rendered as <a href="mailto:…"> so it works with JS off. With JS we
  // swap it for a real <button> that opens the chat widget, falling back to the
  // contact form on this page and finally to the mailto: link.
  function openChatFromCard(fallbackHref) {
    var sc = shopifyChat();
    if (sc) { sc.open(); return; }
    if (goToForm()) return;
    if (fallbackHref) window.location.href = fallbackHref;
  }

  (function upgradeChatCard() {
    var card = document.querySelector('a[data-ocu-chat-card]');
    if (!card || !card.parentNode) return;

    var fallback = card.getAttribute('data-chat-fallback') || card.getAttribute('href') || '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = card.className;
    btn.innerHTML = card.innerHTML;
    btn.setAttribute('data-ocu-chat-card', '');
    btn.setAttribute('data-chat-fallback', fallback);
    btn.setAttribute('aria-label', card.getAttribute('aria-label') || 'Start a live chat');
    if (card.id) btn.id = card.id;
    var testid = card.getAttribute('data-testid');
    if (testid) btn.setAttribute('data-testid', testid);

    btn.addEventListener('click', function () { openChatFromCard(fallback); });
    card.parentNode.replaceChild(btn, card);
  })();

  if (!chat) return;

  // If a real Shopify Inbox widget is present, hide our stand-in bubble so
  // there's only one launcher on screen.
  function hideIfShopifyChat() {
    if (shopifyChat()) {
      chat.style.display = 'none';
    }
  }

  // Check immediately and again after the chat widget may have loaded.
  hideIfShopifyChat();
  setTimeout(hideIfShopifyChat, 2500);

  // Stand-in chat panel open/close.
  var chatLauncher = chat.querySelector('[data-open-chat]');
  function openChat() {
    var sc = shopifyChat();
    if (sc) { sc.open(); return; }
    chat.classList.add('open');
    if (chatLauncher) chatLauncher.setAttribute('aria-expanded', 'true');
    var first = chat.querySelector('[data-chat-to-form]');
    if (first) first.focus();
  }

  function closeChat(restoreFocus) {
    chat.classList.remove('open');
    if (chatLauncher) {
      chatLauncher.setAttribute('aria-expanded', 'false');
      if (restoreFocus) chatLauncher.focus();
    }
  }

  chat.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && chat.classList.contains('open')) {
      e.preventDefault();
      closeChat(true);
    }
  });

  document.querySelectorAll('[data-open-chat]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      chat.classList.contains('open') ? closeChat(true) : openChat();
    });
  });

  document.querySelectorAll('[data-close-chat]').forEach(function (btn) {
    btn.addEventListener('click', function () { closeChat(true); });
  });

  document.querySelectorAll('[data-chat-to-form]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      closeChat();
      if (goToForm()) e.preventDefault();
    });
  });
})();
